let model;

export const setModel = (nextModel) => {
  model = nextModel;
};

export const getModel = () => {
  return model;
};
